import {Component, Inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule} from "@angular/material/dialog";
import {VolumeDiscountProfile} from "../../product-details/interface/volume-discount-profile";
import {VolumeDiscountProfileItem} from "../../product-details/interface/volume-discount-profile-item";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {PipeModule} from "../../pipe/pipe.module";
import {MatButtonModule} from "@angular/material/button";
import {Product} from "../../product-details/interface/product";
import {ProductInformationService} from "../product-information-service";
import {FabricProfileItemList} from "../../product-details/interface/fabric-profile-item-list";

@Component({
	selector: 'fb-product-volume-discount-profile',
	standalone: true,
	imports: [CommonModule, PipeModule, MatDialogModule, MatButtonModule],
	templateUrl: './product-volume-discount-profile.component.html',
	styleUrls: ['./product-volume-discount-profile.component.scss']
})
export class ProductVolumeDiscountProfileComponent implements OnInit {

	public selectedCurrency: ApCurrency = ApCurrency.INR;

	constructor(
		private _currencyResolver: CurrencyResolverService,
		@Inject(MAT_DIALOG_DATA) public data: { product: Product, price: number, volumeDiscountProfile: VolumeDiscountProfile, unit: string, selectedFabric: FabricProfileItemList | undefined },
		private _productService: ProductInformationService
	) {
	}

	ngOnInit() {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
		this.data.volumeDiscountProfile.volumeDiscountProfileItemList = this.data.volumeDiscountProfile.volumeDiscountProfileItemList.sort((a,b) => a.discount - b.discount);
	}

	public calculateDiscountPrice(selectVDProfile: VolumeDiscountProfileItem): number {
		return this._productService.calculateVDProductPrice(
			this.data.product,
			this.data.selectedFabric,
			selectVDProfile,
			selectVDProfile.minimumOrderQuantity
		);
	}
}
